import { useLoaderData } from "react-router-dom";
import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";

function Confirm() {
    const { success } = useLoaderData();

    return (
        <div className="mx-auto prose mt-5 grid max-w-6xl grid-cols-12 gap-x-8 gap-y-6 px-3 pb-24 prose-darkgreen md:mt-10 md:px-10 lg:mt-20">
            <div className="col-span-full flex justify-center">
                {success ? (
                    <div className="flex size-30 shrink-0 items-center justify-center rounded-full bg-emerald-950">
                        <CheckIcon className="size-15 shrink-0 stroke-3 text-darkgreen-500" />
                    </div>
                ) : (
                    <div className="flex size-30 shrink-0 items-center justify-center rounded-full bg-red-600">
                        <XMarkIcon className="size-15 shrink-0 stroke-3 text-beige" />
                    </div>
                )}
            </div>
            <div className="col-span-full text-center">
                <h1 className="mb-4 text-center text-6xl font-semibold tracking-wider">
                    {success ? "Interest confirmed!" : "Confirmation failed"}
                </h1>
                {success && (
                    <p className="lead mx-auto mb-0 max-w-3xl text-neutral-500">
                        You’ll hear from us as soon as onboarding opens, along
                        with clearer details on how Welnido will work for
                        clinicians across different disciplines.
                    </p>
                )}
            </div>
        </div>
    );
}

export default Confirm;
